//@ts-nocheck

import React, { useEffect, useState } from "react";
import { Box, FormControlLabel, Radio, RadioGroup, Typography, } from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
// import { fetchAccountData, } from "../../redux/slice/ledgerSlice";
import { useNavigate } from "react-router-dom";
import { fetchAccountData } from "../redux/slice/ledgerSlice";

const BankAccountRadioGroup = ({ onChange, value, setState }) => {
    const dispatch = useDispatch()
    const bankAccountsRaw = useSelector((store) => store.ledger.accountResponse);
    const investorId = useSelector((store) => store.user.investorId)
    const bankAccounts = Array.isArray(bankAccountsRaw) ? bankAccountsRaw : [];

    useEffect(() => {
        if (bankAccounts && bankAccounts?.length > 0) {
            setState(bankAccounts[0]?.InvAccId)
        }
    }, [bankAccounts])

    useEffect(() => {
        dispatch(fetchAccountData(investorId))
    }, [investorId])

    return (<RadioGroup value={value} onChange={onChange} >
        {bankAccounts && bankAccounts?.length > 0 ? bankAccounts?.map((account, index) => (

            <FormControlLabel
                key={index}
                // className="bg-slate-100"
                className="mb-2"
                value={account.InvAccId}
                control={
                    <Radio
                        sx={{
                            "&.Mui-checked": {
                                color: "#FF5C39", // Change the color when checked
                            },
                        }}
                    />
                }
                sx={{
                    mr: 0,
                    '.MuiFormControlLabel-label': {
                        width: "100%",
                    }
                }}
                label={
                    <Box alignItems="center" className="w-full bg-[#F8F8F8] py-2 px-4 rounded">
                        {account.logo}
                        <Box>
                            <Typography variant="body1" fontSize={16} lineHeight={1.5} color="#3b3b3b" fontWeight={"500"}>
                                {account.BankName}
                            </Typography>
                            <Typography fontSize={14} lineHeight={1.5} fontWeight={"500"} color="#9FA4AB" >
                                Account number XXXX-{account.AccountNumber}
                            </Typography>
                        </Box>
                    </Box>
                }
            />
        )) : bankAccounts && "No bank account Found"}
    </RadioGroup>)
};

export default BankAccountRadioGroup;
